import React from 'react';
import styles from './Radio.scss';
import cx from 'classnames';

export default function Radio(props) {
  return (
    <label className={styles.root}>
      <label
        className={cx({
          [styles.radioLabel]: true,
          [styles.checked]: props.checked,
          [styles.disabled]: props.disabled
        })}>
        <input
          {...props}
          type="radio"/>
      </label>
      {props.labelText}
    </label>
  )
}



/** WEBPACK FOOTER **
 ** ./src/components/Radio/Radio.jsx
 **/